// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"List__Wrapper_2p-sI grid","Item":"List__Item_3qypW","ItemTitle":"List__ItemTitle_1Udwx","ItemPicture":"List__ItemPicture_1Dxii"};